import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { EventsService } from '../services/events.service';
import * as EventsActions from './events.actions';

@Injectable()
export class EventsEffects {
  constructor(
    private actions$: Actions,
    private eventsService: EventsService
  ) {}

  loadEvents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EventsActions.loadEvents),
      mergeMap(() =>
        this.eventsService.getPublishedEvents().pipe(
          map((events) => EventsActions.loadEventsSuccess({ events })),
          catchError((error) =>
            of(EventsActions.loadEventsFailure({ error: error.message }))
          )
        )
      )
    )
  );
}
